var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { getBPHelpers } from '../../utils/breakpoints';
import { gridSizes } from './types';
var mathLogic = function (num) { return (100 / 12) * num; };
var generateWidths = function (theme) {
    var BPHelpers = getBPHelpers(theme.breakpoints);
    var generateResponsiveGridSize = function (size) {
        return gridSizes
            .map(function (item) { return "\n      @media " + BPHelpers.AppBreakpoints.mediaQueries.mobileFirst[size] + " {\n        &." + ("gi-" + item + "-" + size) + " {\n          flex-grow: 0;\n          flex-basis: " + mathLogic(item) + "%;\n          max-width: " + mathLogic(item) + "%;\n        }\n      }\n    "; })
            .join(' ');
    };
    var smallGridSizes = gridSizes
        .map(function (item) { return "\n        &." + ("gi-" + item + "-small") + " {\n          flex-grow: 0;\n          flex-basis: " + mathLogic(item) + "%;\n          max-width: " + mathLogic(item) + "%;\n        }\n      "; })
        .join(' ');
    var mediumGridSizes = generateResponsiveGridSize('medium');
    var largeGridSizes = generateResponsiveGridSize('large');
    var xlargeGridSizes = generateResponsiveGridSize('extra-large');
    return smallGridSizes + " " + mediumGridSizes + " " + largeGridSizes + " " + xlargeGridSizes;
};
var GridItem = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  box-sizing: border-box;\n\n  /* stylelint-disable value-keyword-case */\n  ", " /* stylelint-enable value-keyword-case */\n"], ["\n  margin: 0;\n  box-sizing: border-box;\n\n  /* stylelint-disable value-keyword-case */\n  ", " /* stylelint-enable value-keyword-case */\n"])), function (props) { return generateWidths(props.theme); });
export { GridItem };
var templateObject_1;
//# sourceMappingURL=styles.js.map